import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "p-2 !rounded-2xl group nodrag nopan"
}
const _hoisted_3 = { class: "rounded-lg py-2.5 w-full bg-white" }
const _hoisted_4 = { class: "flex justify-center text-sm text-center leading-5 font-semibold text-gray-700 pt-2" }

interface Props {
    enrolledFrom: string[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'EnrollFromDetails',
  props: {
    enrolledFrom: { default: () => [] }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.enrolledFrom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.enrolledFrom?.join(", ")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})